<button mat-dialog-close class="position-absolute top-0 end-0 cd-btn--no-style">
  <i class="icon icon-close"></i>
</button>
<frontend-auth-client-login></frontend-auth-client-login>
